import classes from './Waveform.module.css';

const PLAYED_COLOUR = 'var(--mantine-color-gray-9)';
const IDLE_COLOUR = 'var(--mantine-color-gray-3)';

type WaveformProps = {
  bars: number[];
  /** Playback position within the segment, 0..1. Zero renders the whole waveform idle. */
  progress: number;
};

export function Waveform({ bars, progress }: WaveformProps) {
  const clamped = Math.min(1, Math.max(0, progress));
  const playedCount = Math.floor(clamped * bars.length);

  return (
    <div className={classes.wave}>
      {bars.map((height, index) => (
        <div
          key={index}
          className={classes.bar}
          style={{
            height: `${Math.round(height * 100)}%`,
            background: index < playedCount ? PLAYED_COLOUR : IDLE_COLOUR,
          }}
        />
      ))}
    </div>
  );
}
